/* @ngInject */
function KanbanTaskCardController ($scope, $timeout, $element, $translate, BriefingService, UserService) {
  $scope.users = []

  $scope.today = new Date().toISOString()

  $scope.flags = {
    isSubtask: false
  }

  const api = {
    _isTaskLate
  }
  this.getApi = () => api

  activate()

  const deregisterAssigneesWatcher = $scope.$watch('task.assignees', function (newValue) {
    activate()
  })

  const deregisterPriorityWatcher = $scope.$watch('task.priority', function (newValue) {
    $scope.hidePriority = !$scope.task.priority
  })

  function activate () {
    if (!$scope.task) {
      return
    }

    if ($scope.task.originType === 'SUBTASK') {
      $scope.flags.isSubtask = true
    }

    if ($scope.task.briefing) {
      $scope.briefingName = BriefingService.limitBriefingNameLength($scope.task.briefing.name)
    }
    if ($scope.task.assignees) {
      if ($scope.task.assignees.length === 1) {
        $scope.users = $scope.task.assignees // show all assignees
      } else {
        $scope.users = $scope.task.assignees.slice(0, 1) // show only 1 assignee
        $scope.assigneesCount = $scope.task.assignees.length - 1 // -1 because the first assignee is already in the users array
      }
    }

    $timeout(() => {
      jQuery($element).find('.kanban-task-card .creation-tooltip').popup({
        delay: {
          show: 1000,
          hide: 0
        }
      })

      jQuery($element).find('.kanban-task-card .assignees-list-tooltip').popup({
        delay: {
          show: 1000,
          hide: 0
        }
      })

      const title = jQuery($element).find('.kanban-task-card .title-tooltip')
      const scrollHeight = title.prop('scrollHeight')
      const height = title.height()

      if (scrollHeight > height) {
        title.popup({
          delay: {
            show: 1000,
            hide: 0
          }
        })
      }
    }, 100, false)

    if (!$scope.task.priority) {
      $scope.hidePriority = true
    }
  }

  $scope.isTaskLate = function () {
    if ($scope.task.isArchived) {
      return false
    } else if ($scope.task && $scope.task.column && $scope.task.column.maximumDaysInColumn && $scope.workingDays) {
      return api._isTaskLate()
    } else {
      return false
    }
  }

  $scope.showStatusAlert = () => {
    if (!$scope.column.defaultStatus) return false
    return $scope.task.status !== $scope.column.defaultStatus
  }

  $scope.getAvatarUrl = (user) => {
    if (!user || !user.id) return null
    return UserService.getUserProfileImage(user.id)
  }

  $scope.getCreationTooltip = (date) => {
    const text = $translate.instant('createdIn')

    const momentDate = moment(date)
    const formattedDate = momentDate.format('L')
    const hour = momentDate.format('HH:mm')

    return `${text}: ${formattedDate} - ${hour}`
  }

  $scope.getAssigneesTooltip = (assignees) => {
    if (!assignees?.length) return

    let text = ''

    assignees.forEach((assignee, index) => {
      text += `${assignee.name}<br>`
    })

    return text
  }

  $scope.getTaskIcon = (task) => {
    if (task.originType === 'TASK') return 'tasks'

    if (task.originType === 'SUBTASK') return 'subtask'

    return task.author?.role === 'USER' ? 'workflow' : 'clipboard'
  }

  $scope.setInfoIconColor = (type, task) => {
    const types = {
      attachments: () => {
        if (task.attachments?.hasUnreadAttachments) {
          return 'feedbackColorRedPure'
        }

        return task.attachments?.count ? 'neutralColorLowMedium' : 'neutralColorLowLight'
      },
      comments: () => {
        if (task.unread_comments) {
          return 'feedbackColorRedPure'
        }

        return task.comments?.count ? 'neutralColorLowMedium' : 'neutralColorLowLight'
      },
      subtasks: () => {
        if (task.subtasks?.hasUnreadSubtask) {
          return 'feedbackColorRedPure'
        }

        return task.subtasks?.count ? 'neutralColorLowMedium' : 'neutralColorLowLight'
      }
    }

    const getColorsByTaskType = types[type]

    if (getColorsByTaskType) {
      return getColorsByTaskType()
    }

    const isDeliveryDateLessThanToday = task?.deliveryDate < $scope.today
    const isNotArchived = !task.isArchived
    const taskIsFinished = task.status === 'DONE'

    if (isDeliveryDateLessThanToday && isNotArchived && !taskIsFinished) {
      return 'feedbackColorRedPure'
    }

    if (task.deliveryDate || taskIsFinished) {
      return 'neutralColorLowMedium'
    }

    return 'neutralColorLowLight'
  }

  function _isTaskLate () {
    const maxDaysInColumn = $scope.task.column.maximumDaysInColumn
    let workingDaysInColumn = 0

    for (let i = 0; i < $scope.task.timeInColumn; i++) { // loop for all days in column and check if they were working days
      moment.locale('en-us')
      const day = moment().subtract(i, 'days').format('dddd').toUpperCase()

      if ($scope.workingDays.includes(day)) {
        workingDaysInColumn++
      }

      if (workingDaysInColumn > maxDaysInColumn) {
        break
      }
    }

    moment.locale('pt-br')
    return workingDaysInColumn > maxDaysInColumn
  }

  $scope.$on('$destroy', () => {
    deregisterAssigneesWatcher()
    deregisterPriorityWatcher()
  })
}

export { KanbanTaskCardController }
